
import { actions, types } from './requests'
export const GETCOLLECTION_TYPES = {
    ...types('GETCOLLECTION'),
}
export const GETCOLLECTION_ACTIONS = {
    ...actions('GETCOLLECTION'),
}